import React from "react";
import { T } from "../../../app/tokens.js";

// Read-only placeholder - no records, requests, or manual-entry controls.
export function ProjectsContracts() {
  return (
    <section aria-label="Contracts" data-testid="projects-contracts"
      style={{ padding: 24, border: `1px solid ${T.projectsStripBorder}`,
        borderRadius: 8, background: T.projectsStripBg, color: T.projectsStripText }}>
      <h2 style={{ margin: "0 0 8px", fontSize: T.fsMd5, fontWeight: T.fwBold }}>
        Contracts - coming soon
      </h2>
      <p style={{ margin: 0, fontSize: T.fsSm }}>Project contracts will be available here.</p>
    </section>
  );
}
